import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Login } from '../models/loginmodel';
import { Session } from '../models/sessionmodel';
import { Observable } from 'rxjs/Rx';
import {config, setConfig} from '../config/config';
import * as CryptoJS from 'crypto-js';
import { SharedService } from './sharedservices.service';
import { environment } from '../environments/environment';

@Injectable()
export class loginService {

    constructor(private http: Http, private sharedservice: SharedService) {

    }

    /*createAuthorizationHeader(headers: Headers) {
        let conversionOutput = CryptoJS.AES.decrypt(localStorage.getItem("mca_d"), config.key).toString(CryptoJS.enc.Utf8);
        let convertedObj = JSON.parse(conversionOutput);
        let conversionSessionOutput = CryptoJS.AES.decrypt(convertedObj["details"], config.key).toString(CryptoJS.enc.Utf8);
        let authconfig = this.sharedservice.session.account_username + ':' + conversionSessionOutput;
        headers.append('Authorization', 'Basic ' +
            btoa(authconfig));
    }*/


    postLogin(login: Login): Observable<Session> {

      const envConfig = setConfig({
        baseEndpoint: environment.BASEENDPOINT,
        baseUrl: environment.BASEENDPOINT,
        key: environment.KEY
      });

        let headers = new Headers();
        let data = JSON.stringify(login);
        /*let authconfig: string = login.username + ':' + login.password;
        headers.append('Authorization', 'Basic ' +
            btoa(authconfig));*/

        //this.createAuthorizationHeader(headers);
        headers.append('Content-Type', 'application/json');

        /*return this.http.post(this.url, data, { headers: headers, withCredentials: true })
            .map(res => res["_body"])
            .catch(this.handleError);*/
      return this.http.post(envConfig.baseUrl + 'auth/login', data, { headers: headers, withCredentials: true })
        .map(res => res)
        .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        // In a real world app, we might use a remote logging infrastructure
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/services/login.service.ts